/**
 * StudioDefinition
 *
 * Contrat déclaratif minimal utilisé par GenericStudioHost.
 *
 * Une définition décrit uniquement les slots de composition UX.
 * Elle ne contient aucun état React, hook, chargement, sauvegarde,
 * moteur Canvas ou comportement métier.
 */

export const STUDIO_DEFINITION_SLOT_NAMES = Object.freeze([
  "header",
  "explorer",
  "canvas",
  "inspector",
  "assets",
  "statusBar",
]);

export function createStudioDefinition({
  id,
  header = null,
  explorer = null,
  canvas = null,
  inspector = null,
  assets = null,
  statusBar = null,
} = {}) {
  if (typeof id !== "string" || id.trim() === "") {
    throw new TypeError(
      "StudioDefinition.id must be a non-empty string."
    );
  }

  return Object.freeze({
    id: id.trim(),
    header,
    explorer,
    canvas,
    inspector,
    assets,
    statusBar,
  });
}

export function isStudioDefinition(value) {
  return Boolean(
    value
      && typeof value === "object"
      && typeof value.id === "string"
      && value.id.trim() !== ""
      && STUDIO_DEFINITION_SLOT_NAMES.every(
        (slotName) => Object.prototype.hasOwnProperty.call(
          value,
          slotName
        )
      )
  );
}
